export const GET_PROCESSES = 'processes/GET_PROCESSES';
export const GET_PROCESSES_SUCCESS = 'processes/GET_PROCESSES_SUCCESS';
export const GET_PROCESSES_FAILED = 'processes/GET_PROCESSES_FAILED';